import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
let ServiceService = class ServiceService {
    constructor(http) {
        this.http = http;
    }
    get_orphan_home_list(param) {
        return this.http.get("http://orphanhome.herokuapp.com/orphanhome/homelist?name=" + param);
    }
    post_orphan_home_list(data) {
        return this.http.post("http://orphanhome.herokuapp.com/orphanhome/homelist", data);
    }
    post_voluntaries_list(data) {
        return this.http.post("http://orphanhome.herokuapp.com/voluntaries/newvoluntaries", data);
    }
    get_voluntaries_list() {
        return this.http.get("http://orphanhome.herokuapp.com/voluntaries/newvoluntaries");
    }
    post_new_donor(data) {
        return this.http.post("http://orphanhome.herokuapp.com/donation/newdonor", data);
    }
};
ServiceService.ctorParameters = () => [
    { type: HttpClient }
];
ServiceService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], ServiceService);
export { ServiceService };
//# sourceMappingURL=service.service.js.map